@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

<div class="card risk-form-card">
  <div class="card-header d-flex align-items-center gap-2">
    <h3 class="card-title mb-0">{{ pageTitle }}</h3>
    @if (code) {
      <span class="badge risk-code-badge">{{ code }}</span>
    }
  </div>

  <div class="card-body">
    <risk-form
      [risk]="risk"
      [riskId]="riskId"
      [isEditPage]="isEditMode"
      (onSavedData)="onFormSavedData($event)">
    </risk-form>
  </div>
</div>
